import React from 'react';
import './css/style.css';

class LoadingSpinner extends React.Component {
    state = {}
    render() {
        return (
            <div>
                <div className='jw-modal modal-dialog'>
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
                    <div className="loading">
                        <div className="loading-bar"></div>
                        <div className="loading-bar"></div>
                        <div className="loading-bar"></div>
                        <div className="loading-bar"></div>
                        <div className="loading-bar"></div>
                    </div>
                </div>
                <div className='jw-modal-background'></div>
            </div>
        );
    }
}

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/LoadingSpinner.jsx